import { Component, OnInit } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { Filter } from "src/app/wings-mobile/models/filter/Filter";
import { Language } from "src/app/wings-mobile/models/language/language";
import { SubDivisionService } from "src/app/wings-mobile/services/subDivision/sub-division.service";
import { WarehouseService } from "src/app/wings-mobile/services/warehouse/warehouse.service";
import { Globals } from "src/app/wings-mobile/shared/globals/globals";
import { GlobalsService } from "src/app/wings-mobile/shared/globals/globals.service";
import { UserResourcesEnum } from '../../../services/resource/user-resources.service';
import { SiteCodeService } from "src/app/wings-mobile/services/siteCode/siteCode.service";
import { ResourceDirective } from "../../../directives/resource.directive";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
    selector: 'settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    imports: [ResourceDirective, SelectModule, FormsModule, TranslatePipe]
})
export class SettingsComponent implements OnInit {

	subDivisions: Filter[];
	selectedSub: Filter;

	warehouses: Filter[];
	selectedWarehouse: Filter;

	languages: Language[];
	selectedLanguage: Language;

	resource = UserResourcesEnum;

	constructor(
		private subDivisionService: SubDivisionService,
		private warehouseService: WarehouseService,
		private siteCodeService: SiteCodeService,
		public globals: Globals,
		public translateService: TranslateService) {
		this.subDivisionService = subDivisionService;
		this.warehouseService = warehouseService;
		this.siteCodeService = siteCodeService;
		this.globals = globals;
		this.translateService = translateService;
		this.languages = [
			{ name: 'Português', lang: 'pt-br' },
			{ name: 'English', lang: 'en-us' },
			{ name: 'Español', lang: 'es-ar' }
		];
	}

	ngOnInit(): void {
		setTimeout(() => this.getAllSubdivisions(), 500);
		this.selectedLanguage = this.languages.find(lang => lang.lang === this.globals.user.language);
	}

	getAllSubdivisions() {
		this.subDivisionService.getAllSubdivisions().subscribe({
			next: res => {
				this.subDivisions = res;
				this.selectedSub = this.subDivisions.find(sub => this.getCountryCode(sub.key) === this.globals.user.country);
				if (this.selectedSub) {
					this.changeSubdivision()
				}
			}
		})
	}

	changeSubdivision() {
		this.warehouseService.getWarehouses(this.selectedSub.key).subscribe({
			next: (res: Filter[]) => {
				this.warehouses = res;
				this.selectedWarehouse = this.warehouses.find(wh => wh.key === this.globals.user.warehouse.warehouseUidK);

			}
		})
	}

	changeWarehouse() {
		if (this.selectedSub && this.selectedWarehouse) {
			let emittedUser = {
				warehouse: {
					bkSubDivisionUidD: this.selectedSub.key,
					warehouseUidK: this.selectedWarehouse.key,
					bkWarehouseC: this.selectedWarehouse.value.split(" ")[0],
					warehouseN: this.selectedWarehouse.value,
					warehouseX: null,
					buildingCodeC: this.selectedWarehouse.extraInfo["siteCode"] != null ? this.selectedWarehouse.extraInfo["siteCode"] : null
				},
				country: this.getCountryCode(this.selectedSub.key),
				userName: this.globals.user.userName
			}


			if (this.selectedWarehouse.extraInfo && this.selectedWarehouse.extraInfo["siteCode"] != null) {
				this.siteCodeService.saveSiteCode(this.selectedWarehouse.extraInfo["siteCode"]).subscribe(() => { });
			}

			GlobalsService.get('changeUser').emit(emittedUser);
		}
	}

	changeLanguage() {
		this.translateService.use(this.selectedLanguage.lang.split('-')[0]);
		GlobalsService.get('changeLanguage').emit(this.selectedLanguage.lang);
	}

	getCountryCode(subdivision: number): string {
		switch (subdivision) {
			case 1:
				return 'ARG';
			case 2:
				return 'BRA';
			case 3:
				return 'CHL';
			case 4:
				return 'COL';
			case 5:
				return 'PER';
			case 6:
				return 'VEN';
		}
	}
}

